module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"dialogTitle":"Aggiorna ImageDescription"}}')
  delete Component.options._Ctor
}
